import { render, staticRenderFns } from "./recommend.vue?vue&type=template&id=93d43d16&scoped=true&"
import script from "./recommend.vue?vue&type=script&lang=js&"
export * from "./recommend.vue?vue&type=script&lang=js&"
import style0 from "./index.scss?vue&type=style&index=0&id=93d43d16&prod&scoped=true&lang=scss&"
import style1 from "./recommend.vue?vue&type=style&index=1&id=93d43d16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d43d16",
  null
  
)

export default component.exports